import { createContext, useContext, useMemo, useState } from 'react';
import { ETypeUser, IConsumption as IConsumptions, IProduct } from '../store/model/store.model';

export type GlobalContextProps = {
    context: IGlobalContext | null;
    setContext: Function;
};

export interface IGlobalContext {
    bundles: IProduct[];
    fibers: IProduct[];
    mobiles: IProduct[];
    rentings: IProduct[];
    typeUser: ETypeUser | null;
    consumptions: IConsumptions[] | null;
}

const _GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);

export const useGlobalContext = () => {
    const { context, setContext } = useContext(_GlobalContext);
    return {
        context,
        setContext,
    };
};

export const GlobalContext = ({ children }: any) => {
    const [context, dispatch] = useState<IGlobalContext>({
        typeUser: null,
        bundles: [],
        fibers: [],
        mobiles: [],
        rentings: [],
        consumptions: null,
    });

    const setContext = (item: IGlobalContext) => {
        dispatch(item);
    };

    const value = useMemo(
        () => ({
            context,
            setContext,
        }),
        [context],
    );

    return <_GlobalContext.Provider value={value}>{children}</_GlobalContext.Provider>;
};
